/* eslint-disable react/prefer-stateless-function */
import React from 'react'
import { Layout, Input, Button, Form, Select, Modal } from 'antd'
import { Query, Mutation } from 'react-apollo'
import { gql } from 'apollo-boost'
import rp from 'request-promise'

const queryEvent = gql`query queryEvent {
  events(
    sort: _ID_DESC
  ) {
    _id
    title
    apiUri
    headers {
      label
      key
    }
  }
}`

const mutationGeneratWithApi = gql`
mutation generateWithApi($eventId: String, $record: TimeInput) {
  generateWithApi(eventId: $eventId record: $record){
    _id
    link
  }
}`

function wrapper(headers, data) {
  const record = {}
  const variables = []
  headers.forEach((head) => {
    record[head.label] = data[head.key]
    variables.push({
      key: head.label,
      value: data[head.key],
    })
  })

  record.variables = variables

  return record
}

class WithApi extends React.Component {
  state = {
    bib: null,
    indexEventSelected: null,
    runnerResult: {},
    previewResults: {},
    loadingRequest: false,
    loadingGenerate: false,
  }

  handleChangeEvent = (index) => {
    this.setState({
      indexEventSelected: index,
    })
  }

  RequestApi = async (uri, bib, headers) => {
    // this.setState({ loadingRequest: true })
    const response = await rp.get(`${uri}?filter=([ATF1]="${bib}")`)
    const [runnerResult] = JSON.parse(response)
    if (runnerResult) {
      const times = wrapper(headers, runnerResult)
      delete times.variables
      this.setState({
        runnerResult: wrapper(headers, runnerResult),
        previewResults: times,
        loadingRequest: false,
      })
    } else {
      Modal.info({
        title: 'No Result',
      })
      this.setState({
        loadingRequest: false,
      })
    }
  }

  generate = async (generateWithApi, event) => {
    this.setState({
      loadingGenerate: true,
    })
    const { runnerResult } = this.state
    // runnerResult.bibNumber = parseInt(runnerResult.bib, 10)
    // runnerResult.race = 0

    const record = {
      slug: event.slug,
      bib: runnerResult.bib,
      bibNumber: parseInt(runnerResult.bib, 10),
      race: '0',
      variables: runnerResult.variables,
      eSlip: true,
    }
    const { data } = await generateWithApi({
      variables: {
        eventId: event._id,
        record,
      },
    })
    this.setState({
      loadingGenerate: false,
    })
    if (data.generateWithApi) {
      window.open(data.generateWithApi.link, '_blank')
    }
  }

  render() {
    const {
      bib, indexEventSelected, previewResults, loadingGenerate, loadingRequest,
    } = this.state
    return (
      <Query query={queryEvent}>
        {({ data: { events }, loading, error }) => {
            if (error) return <div>something error</div>
            if (loading) return <div>loading event...</div>

            return (
              <Layout>
                <Layout.Header>
                  <h1 style={{ color: '#fff' }}>Create with API.</h1>
                </Layout.Header>
                <Layout.Content style={{ width: '80%', margin: '0 auto' }}>
                  <Form layout="inline">
                    <Form.Item>
                      <Select style={{ width: '400px' }} onChange={e => this.handleChangeEvent(e)}>
                        {events.map((event, index) => <Select.Option key={event._id} value={index}>{event.title}</Select.Option>)}
                      </Select>
                    </Form.Item>
                    <Form.Item>
                      <Input value={bib} onChange={e => this.setState({ bib: e.target.value })} placeholder="Insert Bib" />
                    </Form.Item>
                  </Form>
                  {
                    (indexEventSelected !== null) && events[indexEventSelected].apiUri ?
                      <div>
                        <p>api uri: {events[indexEventSelected].apiUri}</p>
                        <div>
                          <Button type="primary" onClick={() => this.RequestApi(events[indexEventSelected].apiUri, bib, events[indexEventSelected].headers)} disabled={!bib} loading={loadingRequest}>Request data</Button>
                        </div>
                        <div>
                          {
                            previewResults.bib ? <pre>{JSON.stringify(previewResults, null, 2)}</pre> : null
                          }
                        </div>
                        {
                          previewResults.bib ?
                            <div>
                              <Mutation mutation={mutationGeneratWithApi}>
                                {generateWithApi => <Button onClick={() => this.generate(generateWithApi, events[indexEventSelected])} loading={loadingGenerate}>Generate</Button>}
                              </Mutation>
                            </div> :
                          null
                            }
                      </div>
                    : null
                }
                </Layout.Content>
              </Layout>
            )
          }}
      </Query>
    )
  }
}

export default WithApi



// WEBPACK FOOTER //
// ./src/CreateEcer/WithApi.js